import React from "react";
import { Card, Typography } from "antd";
import StandardContainerLayout from "../../layouts/StandardContainerLayout";
import { useSelector } from "react-redux";

const { Title } = Typography;

const IncidentReport = () => {
  const { role, firstname, lastname } = useSelector(({ auth }) => auth.user);
  
  // Construct the Zoho form URL with the user's name
  const userFullName = `${firstname} ${lastname}`;
  const zohoFormUrl = `https://creatorapp.zohopublic.com/justinkaese3/safetycloud/form-embed/Add_Incident_Record/HSzb8tS0BRxs2ZkzgHCst1WGdD9wQwugjMWtSHUhtC1wJw1tSW1VFfp4P5d1RP29F4x4hbeFBBDCg10KhEbU9fy9k1Gxs0D06AKZ?Recorded_By_External_Member=${encodeURIComponent(userFullName)}`;

  return (
    <StandardContainerLayout>
      <div style={{ padding: "24px" }}>
        <Card>
          <Title level={2} style={{ marginBottom: "24px" }}>
            Incident Report
          </Title>
          <p style={{ marginBottom: "24px", color: "#666" }}>
            Please fill out the incident report form below. All fields marked with an asterisk (*) are required.
          </p>
          
          <iframe 
            height='500px' 
            width='100%' 
            frameBorder='0' 
            allowTransparency='true' 
            scrolling='auto' 
            src={zohoFormUrl}
            title="Incident Report Form"
            style={{ border: "1px solid #d9d9d9", borderRadius: "6px" }}
          />
        </Card>
      </div>
    </StandardContainerLayout>
  );
};

export default IncidentReport; 